/** @module Enums */ /** typedoc */
var ReleaseStateEnum;
(function (ReleaseStateEnum) {
    ReleaseStateEnum["Draft"] = "Draft";
    ReleaseStateEnum["ConfirmDraft"] = "ConfirmDraft";
    ReleaseStateEnum["PendingApproval"] = "PendingApproval";
    ReleaseStateEnum["Rejected"] = "Rejected";
    ReleaseStateEnum["PendingRelease"] = "PendingRelease";
    ReleaseStateEnum["Released"] = "Released";
    ReleaseStateEnum["PendingTakeDown"] = "PendingTakeDown";
    ReleaseStateEnum["PendingSelfPause"] = "PendingSelfPause";
    ReleaseStateEnum["TakenDown"] = "TakenDown";
    ReleaseStateEnum["Paused"] = "Paused";
    ReleaseStateEnum["PendingPause"] = "PendingPause";
    ReleaseStateEnum["SelfPaused"] = "SelfPaused";
})(ReleaseStateEnum || (ReleaseStateEnum = {}));

export { ReleaseStateEnum };
